var ResultListViewBase = ViewModel.extend({
    template: _.template($('#resultListItemTemplate').html().trim()),

    render: function () {

        var data = this.safeData();

        this.$el.empty();

        _.each(data.AddressItems, function (Item, Index) {
            Item.Index = Index;

            $($.trim(this.template(Item))).appendTo(this.$el);
        }, this);

        return this;
    }
});

var ResultListView = ResultListViewBase.extend({

    setCurrentPage: function (currentPage) {
        this.currentPage = currentPage;
    },

    setSearchMode: function (searchMode) {
        this.searchMode = searchMode;
    },

    render: function () {
        var data = this.safeData();

        this.$el.empty();

        _.each(data.AddressItems, function (Item, Index) {
            Item.Index = Index;

            var BranchCodes = _.map(Item.BasicData.BranchListElements, function (el) {
                return el.BranchCode;
            });

            //BranchCodes.push("GTBIB0172");

            $($.trim(this.template(_.extend(Item, {
                currentPage: this.currentPage,
                BranchCodes: BranchCodes,
                searchMode: this.searchMode
            })))).appendTo(this.$el);
        }, this);

        return this;
    }
});